module.exports = "/_next/static/images/Trend05Visual@2x-4978e192a8d2bba04217b3ac0ab34041.png";